<!-- 微信服务号: 密钥模式 -->
<template>
  <div class="official-secret">
    <vh-card
      v-if="officalCfg"
      class="offical-cfg-card"
      shadow="never"
      :body-style="{ padding: '0px' }"
    >
      <div class="offical-cfg-card__hd">
        <div class="cfg-item">
          <div class="cfg-item__title">{{ $t('lang.k_319032') }}：</div>
          <div class="cfg-item__content">{{ officalCfg.name }}</div>
        </div>
        <div class="cfg-item">
          <div class="cfg-item__title">AppID：</div>
          <div class="cfg-item__content">{{ officalCfg.appid }}</div>
        </div>
        <div class="cfg-item">
          <div class="cfg-item__title">AppSecret：</div>
          <div class="cfg-item__content">
            <vh-tooltip
              class="item"
              :manual="true"
              effect="dark"
              :content="officalCfg.secret"
              placement="right"
              v-model="showSecret"
            >
              <vh-button type="text" @click="handleViewSecret">
                {{ showSecret ? $t('lang.k_319033') : $t('lang.k_319034') }}
              </vh-button>
            </vh-tooltip>
          </div>
        </div>
        <div class="cfg-item">
          <div class="cfg-item__title">{{ $t('lang.k_319035') }}：</div>
          <div class="cfg-item__content">{{ officalCfg.redirect_domain }}</div>
          <div class="cfg-item__ft">
            <vh-button round size="mini" @click="handleUploadReady">
              {{ $t('lang.k_319036') }}
            </vh-button>
          </div>
        </div>
      </div>
      <div class="offical-cfg-card__ft" @click="handleDelete" v-preventReClick>
        {{ $t('lang.k_319010') }}
      </div>
    </vh-card>
    <div v-else>
      <null-page nullType="setting" :text="$t('lang.k_319011')">
        <vh-button type="primary" round @click="handleReadyAdd" v-preventReClick>
          {{ $t('lang.k_319012') }}
        </vh-button>
      </null-page>
    </div>

    <!-- 添加自有服务号对话框 -->
    <vh-dialog
      custom-class="dialog-self-official"
      :visible.sync="selfOfficialVisible"
      width="700px"
      :title="$t('lang.k_319037')"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <vh-form ref="form" :model="form" :rules="rules" label-width="110px">
        <vh-form-item :label="$t('lang.k_319032')" prop="name" required>
          <vh-input v-model.trim="form.name"></vh-input>
        </vh-form-item>
        <vh-form-item label="AppID" prop="appid" required>
          <vh-input v-model.trim="form.appid"></vh-input>
        </vh-form-item>
        <vh-form-item label="AppSecret" prop="secret" required>
          <vh-input v-model.trim="form.secret"></vh-input>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_319035')" required>
          <vh-input v-model.trim="form.redirect_domain" disabled></vh-input>
          <i18n path="lang.k_319038" tag="div" class="domain-tip">
            <template>
              <vh-button round size="mini" @click="handleUploadReady">
                {{ $t('lang.k_319036') }}
              </vh-button>
            </template>
          </i18n>
        </vh-form-item>
      </vh-form>
      <span slot="footer" class="dialog-footer create-footer">
        <vh-button type="primary" size="medium" v-preventReClick @click="handleSubmit" round>
          {{ $t('lang.k_319039') }}
        </vh-button>
        <vh-button size="medium" @click="handleCancel" plain round>
          {{ $t('lang.k_319018') }}
        </vh-button>
      </span>
    </vh-dialog>

    <!-- 上传校验文件对话框 -->
    <vh-dialog
      custom-class="dialog-official-upload"
      :visible.sync="uploadVisible"
      width="500px"
      :title="$t('lang.k_319036')"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <vh-upload
        ref="upload"
        class="upload-container"
        drag
        action="#"
        accept="text/plain"
        :auto-upload="false"
        :on-change="handleUploadChange"
        v-loading="uploadLoading"
      >
        <i class="vh-icon-upload"></i>
        <div class="vh-upload__text">
          {{ $t('lang.k_319045') }}
          <em>{{ $t('lang.k_319046') }}</em>
        </div>
        <div class="vh-upload__tip" slot="tip">{{ $t('lang.k_319047') }}</div>
      </vh-upload>
    </vh-dialog>
  </div>
</template>
<script>
  import to from 'await-to-js';
  import { safeJsonParse, sessionOrLocal } from '@/utils/utils';
  import NullPage from '../../PlatformModule/Error/nullPage.vue';
  import { isEmpty } from '@/utils/utils.js';

  export default {
    name: 'OfficialSecret',
    components: {
      NullPage
    },
    data() {
      return {
        userId: '',
        officalCfg: null,
        showSecret: false,
        selfOfficialVisible: false,
        form: {
          name: '',
          appid: '',
          secret: '',
          redirect_domain: ''
        },
        rules: {
          name: [{ required: true, message: this.$t('lang.k_319041'), trigger: 'blur' }],
          appid: [{ required: true, message: this.$t('lang.k_319042'), trigger: 'blur' }],
          secret: [{ required: true, message: this.$t('lang.k_319043'), trigger: 'blur' }]
        },
        uploadVisible: false,
        uploadLoading: false
      };
    },
    created() {
      this.userId = JSON.parse(sessionOrLocal.get('userId'));
    },
    mounted() {
      this.getSelfOfficalConfig();
    },
    methods: {
      // 获取自有公众号配置配置信息
      async getSelfOfficalConfig() {
        const params = {
          business_uid: this.userId,
          config_type: 21,
          config_subtype: 1
        };
        const [err, res] = await to(this.$fetch('getChatAuditSet', params));
        if (err || !res || res.code != 200 || !res.data) {
          this.$message.error(err.msg || res?.msg || this.$t('lang.k_291067'));
          return false;
        }
        const cfgValue = safeJsonParse(res.data.config_value);
        this.officalCfg = isEmpty(cfgValue) ? null : cfgValue;
      },
      // 查看密钥
      async handleViewSecret() {
        this.showSecret = !this.showSecret;
      },
      handleReadyAdd() {
        const watchUrlObj = new URL(window.domainOfWatch());
        this.form.redirect_domain = watchUrlObj?.host || '';
        this.selfOfficialVisible = true;
      },
      // 保存
      async handleSubmit() {
        const [error, valid] = await to(this.$refs.form.validate());
        if (error || !valid) return;

        const [cancel, confirm] = await to(
          this.$vhConfirm(this.$t('lang.k_319040'), this.$t('lang.k_395059'), {
            confirmButtonText: this.$t('lang.k_395060'),
            cancelButtonText: this.$t('lang.k_395061'),
            roundButton: true
          })
        );
        if (cancel) return;
        const params = {
          config_type: 21,
          config_subtype: 1,
          config_value: JSON.stringify(this.form)
        };
        const [err, res] = await to(this.$fetch('saveChatAuditSet', params));
        if (err || !res || res.code != 200) {
          this.$message.error(err.msg || res?.msg || this.$t('lang.k_291067'));
          return false;
        }
        this.officalCfg = {
          ...this.form
        };
        this.selfOfficialVisible = false;
        this.$vhMessage.success(this.$t('lang.k_319044'));
        this.$refs.form.resetFields();
      },
      handleCancel() {
        this.selfOfficialVisible = false;
      },
      async handleDelete() {
        const [cancel, confirm] = await to(
          this.$vhConfirm(this.$t('common.c_001001'), this.$t('common.c_001002'), {
            confirmButtonText: this.$t('common.c_001003'),
            cancelButtonText: this.$t('common.c_001004'),
            roundButton: true
          })
        );
        if (cancel) return;
        const params = {
          config_type: 21,
          config_subtype: 1,
          config_child_type: 1
        };
        const [err, res] = await to(this.$fetch('deleteBusinessConfig', params));
        if (err || !res || res.code != 200) {
          this.$message.error(err.msg || res?.msg || this.$t('lang.k_291067'));
          return false;
        }
        this.officalCfg = null;
        this.$vhMessage.success(this.$t('common.c_001005'));
      },
      handleUploadReady() {
        this.uploadLoading = false;
        this.uploadVisible = true;
      },
      handleUploadChange(file, fileList) {
        // console.log('file：', file);
        const that = this;
        // 实际的 File 对象在 file.raw 中
        const rawFile = file.raw;
        if (!rawFile) {
          that.$vhMessage.error(that.$t('lang.k_319048'));
          return false;
        }
        // 验证文件类型 text/plain
        if (!rawFile.type.includes('text/plain')) {
          that.$vhMessage.error(that.$t('lang.k_319049'));
          return false;
        }
        const isLt = file.size / 1024 < 10;
        if (!isLt) {
          that.$vhMessage.error(that.$t('lang.k_319050'));
          return false;
        }
        that.uploadLoading = true;
        const reader = new FileReader();
        reader.onload = async function (e) {
          const content = e.target.result;
          const params = {
            business_uid: that.userId,
            file_name: file.name,
            file_content: content
          };
          // console.log('params:', params);
          const [err, res] = await to(
            that.$fetch('uploadWechatVerifyFile', params, {
              'Content-Type': 'application/json'
            })
          );
          that.uploadLoading = false;
          if (err || !res || res.code != 200) {
            that.$message.error(err.msg || res?.msg || that.$t('lang.k_291067'));
            return false;
          }
          that.$refs.upload && that.$refs.upload.clearFiles();
          that.uploadVisible = false;
          that.$vhMessage.success(that.$t('lang.k_319051'));
        };
        reader.onerror = function () {
          that.uploadLoading = false;
          that.$refs.upload && that.$refs.upload.clearFiles();
          that.$vhMessage.error(that.$t('lang.k_319052'));
        };
        reader.readAsText(rawFile, 'UTF-8'); // 指定编码
      }
    }
  };
</script>
<style lang="less" scoped>
  .official-secret {
    width: 100%;
    height: auto;
    background: #ffffff;
    border-radius: 4px;
    padding: 48px 40px 40px 40px;
    overflow: hidden;
    min-height: 676px;

    .offical-cfg-card {
      width: 420px;

      &__hd {
        padding: 20px 24px;
        background-color: #f5f5f5;

        .cfg-item {
          font-size: 14px;
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 40px;
          &__title {
            width: 100px;
            display: inline-block;
          }
          &__content {
            flex: 1;

            .view-secret {
              cursor: pointer;
              &:hover {
                color: #000;
              }
            }
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      &__ft {
        display: flex;
        // width: 308px;
        padding: 7px 0px;
        justify-content: center;
        align-items: center;
        border-radius: 0px 0px 4px 4px;
        background-color: rgba(0, 0, 0, 0.45);
        color: rgba(255, 255, 255, 0.85);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        box-sizing: border-box;
        height: 36px;
        cursor: pointer;
      }
    }

    .domain-tip {
      line-height: 1.6;
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
    }
  }
</style>
<style lang="less">
  .dialog-official-upload {
    .vh-dialog__body {
      height: 240px;
    }

    .upload-container {
      margin-top: 30px;
      text-align: center;

      .vh-upload--picture-card,
      .vh-upload-dragger {
        width: 300px;
        height: 135px;

        .vh-icon-upload,
        .vh-upload__text {
          line-height: 1.6;
        }
      }
    }
  }
</style>
